<template>
  <div>
    <WidgetLoad/>
  </div>
</template>

<script>
// @ is an alias to /src
import WidgetLoad from '@/components/Widgets';

export default {
  name: 'Dashboard',
  components: {
    WidgetLoad,
  },
};
</script>
